import React from "react";

export function Input({label,hint,error,prefix,suffix,size="md",disabled=false,style,...rest}){
  const [focus,setFocus]=React.useState(false);
  const h=size==="sm"?"var(--control-h-sm)":size==="lg"?"var(--control-h-lg)":"var(--control-h)";
  return (
    <label style={{display:"block",...style}}>
      {label&&<span style={{display:"block",marginBottom:"6px",fontFamily:"var(--font-display)",fontSize:"var(--text-xs)",fontWeight:"var(--weight-semibold)",letterSpacing:"var(--tracking-wide)",color:"var(--fg-1)"}}>{label}</span>}
      <span style={{display:"flex",alignItems:"center",gap:"8px",height:h,padding:"0 12px",
        background:disabled?"var(--surface-sunken)":"var(--surface-card)",
        border:"1px solid "+(error?"var(--red-600)":focus?"var(--cyan-500)":"var(--line-default)"),
        borderRadius:"var(--radius-control)",transition:"var(--transition-control)",
        boxShadow:focus&&!error?"0 0 0 3px var(--cyan-100)":"none"}}>
        {prefix&&<span style={{color:"var(--fg-3)",display:"inline-flex"}}>{prefix}</span>}
        <input disabled={disabled} onFocus={()=>setFocus(true)} onBlur={()=>setFocus(false)}
          style={{all:"unset",flex:1,minWidth:0,fontFamily:"var(--font-body)",fontSize:"var(--text-sm)",color:"var(--fg-1)",cursor:disabled?"not-allowed":"text"}}
          {...rest}/>
        {suffix&&<span style={{color:"var(--fg-3)",display:"inline-flex"}}>{suffix}</span>}
      </span>
      {(hint||error)&&<span style={{display:"block",marginTop:"6px",fontSize:"var(--text-2xs)",color:error?"var(--text-danger)":"var(--fg-3)"}}>{error||hint}</span>}
    </label>
  );
}
